import type { NodeProps } from "@xyflow/react";
import styled from "styled-components";
import { NodeSectionLabel } from "./NodeSectionLabel";
import { CARD_WIDTH } from "../graph/constants";
import type { FlowNodeData } from "../graph/types";

/* Span the same width as the action cards below so the header's text lines up
 * with the cards' left edge. The layout centers every node on the stack axis;
 * matching CARD_WIDTH makes this node's left edge sit exactly under the cards'
 * (NodeSectionLabel is already left-aligned via align-items: flex-start). */
const StyledSectionLabelNode = styled.div`
  width: ${CARD_WIDTH}px;
`;

/**
 * Standalone "Then / do this" section header node. It is non-draggable and has
 * no edges, so it stays put while the action cards below it are reordered — and
 * because the header no longer lives inside the first action card, every action
 * node has the same measured geometry, keeping the drag drop-slot math uniform.
 */
export const SectionLabelNode = ({ data }: NodeProps): React.ReactElement => {
  const { label } = data as Extract<FlowNodeData, { kind: "sectionLabel" }>;
  return (
    <StyledSectionLabelNode>
      <NodeSectionLabel label={label} />
    </StyledSectionLabelNode>
  );
};
SectionLabelNode.displayName = "SectionLabelNode";
